import React from 'react';
import PropTypes from 'prop-types';
import AdvForm from '../../../CommonComponents/AdvForm';
import {
  simpleSelectDefaultValue,
  simpleSelectChangedToNonNull,
} from '../../../Profile/Accounts_react/AccountsUtils';
import { isNumeric, createCustomPropType, isUuid } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';

const View = ({
  clientId,
  title,
  groupTitle,
  areOptionsLoaded,
  goalId,
  whatIfType,
  storeData,
  principalStartAge,
  principalDuration,
  spouseStartAge,
  spouseDuration,
  principalName,
  spouseName,
  hasSpouse,
  spouseLtcStartAgeOptions,
  principalLtcStartAgeOptions,
  durationOptions,
}) => (
  <div className="what-ifs-layout-content">
    <h4 className="what-if-group-title">{groupTitle}</h4>
    <AdvForm>
      <ValidationErrors clientId={clientId} />
      <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
        <li className="what-ifs-form-field">
          <h5 className="what-if-title">{title}</h5>
        </li>
        <li className="what-ifs-form-field">
          <label className="what-ifs-insurance-label" htmlFor="PrincipalStartAge">
            <span className="what-ifs-ltc-label-text">{principalName}</span>
            <br />
            <div className="what-ifs-ltc-needs-layout">
              <div className="what-ifs-ltc-needs-layout-text">Starting at age</div>
              <div className="what-ifs-ltc-needs-layout-select">
                <Select
                  isPortal
                  id="PrincipalStartAge"
                  value={simpleSelectDefaultValue(principalLtcStartAgeOptions, principalStartAge)}
                  onChange={simpleSelectChangedToNonNull(
                    clientId,
                    storeData(goalId, whatIfType),
                    'WhatIf.PrincipalStartAge',
                  )}
                  options={principalLtcStartAgeOptions}
                />
              </div>
            </div>
            <div className="what-ifs-ltc-needs-layout">
              <div className="what-ifs-ltc-needs-layout-text">for</div>
              <div className="what-ifs-ltc-needs-layout-select">
                <Select
                  isPortal
                  id="PrincipalDuration"
                  value={simpleSelectDefaultValue(durationOptions, principalDuration)}
                  onChange={simpleSelectChangedToNonNull(
                    clientId,
                    storeData(goalId, whatIfType),
                    'WhatIf.PrincipalDuration',
                  )}
                  options={durationOptions}
                />
              </div>
              <div className="what-ifs-ltc-needs-layout-text">
                year{principalDuration > 1 && 's'}
              </div>
            </div>
          </label>
        </li>

        {hasSpouse && (
          <li className="what-ifs-form-field">
            <label className="what-ifs-insurance-label" htmlFor="SpouseStartAge">
              <span className="what-ifs-ltc-label-text">{spouseName}</span>
              <br />
              <div className="what-ifs-ltc-needs-layout">
                <div className="what-ifs-ltc-needs-layout-text">Starting at age</div>
                <div className="what-ifs-ltc-needs-layout-select">
                  <Select
                    isPortal
                    id="SpouseStartAge"
                    value={simpleSelectDefaultValue(spouseLtcStartAgeOptions, spouseStartAge)}
                    onChange={simpleSelectChangedToNonNull(
                      clientId,
                      storeData(goalId, whatIfType),
                      'WhatIf.SpouseStartAge',
                    )}
                    options={spouseLtcStartAgeOptions}
                  />
                </div>
              </div>
              <div className="what-ifs-ltc-needs-layout">
                <div className="what-ifs-ltc-needs-layout-text">for</div>
                <div className="what-ifs-ltc-needs-layout-select">
                  <Select
                    isPortal
                    id="SpouseDuration"
                    value={simpleSelectDefaultValue(durationOptions, spouseDuration)}
                    onChange={simpleSelectChangedToNonNull(
                      clientId,
                      storeData(goalId, whatIfType),
                      'WhatIf.SpouseDuration',
                    )}
                    options={durationOptions}
                  />
                </div>
                <div className="what-ifs-ltc-needs-layout-text">
                  year{spouseDuration > 1 && 's'}
                </div>
              </div>
            </label>
          </li>
        )}
      </ul>
    </AdvForm>
  </div>
);
View.defaultProps = {
  title: '',
  groupTitle: '',
  spouseName: '',
  spouseStartAge: 65,
  spouseDuration: 5,
};

View.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  whatIfType: PropTypes.number.isRequired,
  storeData: PropTypes.func.isRequired,
  hasSpouse: PropTypes.bool.isRequired,
  principalName: PropTypes.string.isRequired,
  spouseName: PropTypes.string,
  spouseStartAge: PropTypes.number,
  principalStartAge: PropTypes.number.isRequired,
  spouseDuration: PropTypes.number,
  principalDuration: PropTypes.number.isRequired,
  spouseLtcStartAgeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  durationOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  principalLtcStartAgeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default View;
